import { AgGridModule } from "@bfx/ag-grid-angular";
import { AutoCompleteModule } from "@bfx/primeng/autocomplete";
import { ButtonModule } from "@bfx/primeng/button";
import { CheckboxModule } from "@bfx/primeng/checkbox";
import { CommonModule } from "@angular/common";
import { DialogModule } from "@bfx/primeng/dialog";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { OverlayPanelModule } from "@bfx/primeng/overlaypanel";
import { TranslateModule } from "@ngx-translate/core";

import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { BfxBlotterFilterModule } from "../bfx-blotter-filter/bfx-blotter-filter.module";
import { BfxBaseBlotterColumnSelectorService } from "../bfx-base-blotter/bfx-base-blotter-columnselector.service";
import { BfxVwapModule } from "../bfx-vwap/bfx-vwap.module";
import { BfxMenusModule } from "../bfx-menus/bfx-menus.module";
import { BfxAlgoMonitorFilteringService } from "./services/bfx-algo-monitor-filter.service";
import { BfxAlgoMonitor } from "./bfx-algo-monitor";
import { BfxBlotterOrdersActionSubjectModule } from "../bfx-blotter-orders/bfx-blotter-orders-action-subject.module";
import { BfxAlgoMonitorContextMenu } from "./bfx-algo-monitor-contextmenu";
import { BfxAlgoMonitorContextMenuService } from "./bfx-algo-monitor-contextmenu.service";
import { BfxAlgoMonitorService } from "./services/bfx-algo-monitor.service";
import { BaseComponentsModule } from "shared/base-components/base-components.module";
import { BfxRiskTradeBlotterModule } from "app/bfx-blotter-risk-trade/bfx-risk-trade-blotter.module";
import { BfxAlgoRiskTradeBlotterComponent } from "app/bfx-algo-monitor/bfx-algo-risk-trade-blotter.component";
import { BfxAlgoRiskTradeBlotterService } from "app/bfx-algo-monitor/services/bfx-algo-risk-trade-blotter.service";
import { CubiqServicesPrimaryModule } from "shared/cubiq-services/module/CubiqServicesPrimaryModule";
import { BfxElementsLibraryModule } from "app/bfx-element-library/bfx-elements-library.module";
import { BfxInterfaceControlsModule } from "app/bfx-interface-controls/bfx-interface-controls.module";

@NgModule({
  declarations: [BfxAlgoMonitorContextMenu, BfxAlgoMonitor, BfxAlgoRiskTradeBlotterComponent],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    FlexLayoutModule,
    AutoCompleteModule,
    CheckboxModule,
    DialogModule,
    ButtonModule,
    OverlayPanelModule,
    AgGridModule.withComponents([]),
    BfxVwapModule,
    BfxSharedModule,
    BfxBlotterFilterModule,
    BfxMenusModule,
    BaseComponentsModule,
    BfxBlotterOrdersActionSubjectModule,
    BfxRiskTradeBlotterModule,
    CubiqServicesPrimaryModule,
    BfxElementsLibraryModule,
    BfxInterfaceControlsModule,
  ],
  exports: [BfxAlgoMonitor],
  providers: [
    BfxAlgoMonitorContextMenuService,
    BfxAlgoMonitorFilteringService,
    BfxBaseBlotterColumnSelectorService,
    BfxAlgoMonitorService,
    BfxAlgoRiskTradeBlotterService,
  ],
  bootstrap: [BfxAlgoMonitor],
})
export class BfxAlgoMonitorModule {}
